module.exports = __webpack_public_path__ + "static/media/reservation_fee.57f3e8a3.svg";